import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom"
import { AuthProvider } from "~/AuthContext"
import Layout from "~/components/Layout"
import Guarded from "~/components/Guarded"
import routes from "~/routes"
import Home from "~/pages/Home"
import Cleans from "~/pages/Cleans"
import Residencies from "~/pages/Residencies"
import Cleaners from "~/pages/Cleaners"
import NewCleaner from "~/pages/NewCleaner"
import Notifications from "~/pages/Notifications"
import Settings from "~/pages/Settings"
import SignIn from "~/pages/SignIn"
import ForgotPassword from "~/pages/ForgotPassword"
import ResetPassword from "~/pages/ResetPassword"
import CleanerPortal from "~/pages/CleanerPortal"
import SendMessage from "~/pages/SendMessage"
import BookingForm from "~/pages/BookingForm"
import BookingDetail from "~/pages/BookingDetail"

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path={routes.signIn} element={<SignIn />} />
          <Route path={routes.forgotPassword} element={<ForgotPassword />} />
          <Route path={routes.resetPassword.pattern} element={<ResetPassword />} />
          <Route path={routes.cleanerPortal.pattern} element={<CleanerPortal />} />

          <Route element={<Guarded><Layout /></Guarded>}>
            <Route path={routes.home} element={<Home />} />
            <Route path={routes.cleans} element={<Cleans />} />
            <Route path={routes.residencies} element={<Residencies />} />
            <Route path={routes.cleaners} element={<Cleaners />} />
            <Route path={routes.newCleaner} element={<NewCleaner />} />
            <Route path={routes.notifications} element={<Notifications />} />
            <Route path={routes.settings} element={<Settings />} />
            <Route path={routes.sendMessage.pattern} element={<SendMessage />} />
            <Route path={routes.newBooking} element={<BookingForm />} />
            <Route path={routes.editBooking.pattern} element={<BookingForm />} />
            <Route path={routes.bookingDetail.pattern} element={<BookingDetail />} />
            <Route path="*" element={<Navigate to={routes.home} replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
